import * as api from "../api/index";

import {
  ADD_NEW_ASSISTANT,
  UPDATE_ASSISTANT,
  DELETE_ASSISTANT,
  START_LOADING,
  END_LOADING,
  FETCH_ASSISTANTS_BY_USER,
} from "./constants";

export const createAssistant =
  (assistant, openSnackbar) => async (dispatch) => {
    try {
      const { data } = await api.addAssistant(assistant);
      dispatch({ type: ADD_NEW_ASSISTANT, payload: data.result });
      openSnackbar("Assistant added successfully");
    } catch (error) {
      console.log(error);
    }
  };

export const updateAssistant =
  ({ currentId, assistantData, openSnackbar }) =>
  async (dispatch) => {
    let id = currentId;
    let assistant = assistantData;

    const { data } = await api.updateAssistant(id, assistant);
 
    dispatch({ type: UPDATE_ASSISTANT, payload: data });
    openSnackbar("Assistant updated successfully");
    try {
    } catch (error) {
      console.log(error);
    }
  };

export const deleteAssistant = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteAssistant(id);

    dispatch({ type: DELETE_ASSISTANT, payload: id });
    openSnackbar("Assistant deleted successfully");
  } catch (error) {
    console.log(error);
  }
};
export const getAssistantsByUser = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const {
      data: { data },
    } = await api.fetchAssistantsByUser(searchQuery);

    dispatch({ type: FETCH_ASSISTANTS_BY_USER, payload: data });

    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error.response);
  }
};
